import { render, staticRenderFns } from "./PoliciesRegulations.vue?vue&type=template&id=b04a8330"
import script from "./PoliciesRegulations.vue?vue&type=script&lang=js"
export * from "./PoliciesRegulations.vue?vue&type=script&lang=js"
import style0 from "./PoliciesRegulations.vue?vue&type=style&index=0&id=b04a8330&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports